import Skeleton from "react-loading-skeleton";

const FIELD_ROWS = 6;
const COLUMNS = [0, 1];

// opaque so the editor's own boot screen stays hidden until it reports ready
export function BnxtEditorSkeleton() {
    return (
        <div className="external-editor__skeleton" data-cy="bnxtEditor.skeleton">
            <Skeleton height={32} width="40%" className="external-editor__skeleton-title"/>
            <div className="external-editor__skeleton-columns">
                {COLUMNS.map((column) => (
                    <div key={column} className="external-editor__skeleton-column">
                        {Array.from({length: FIELD_ROWS}, (_, row) => (
                            <div key={row} className="external-editor__skeleton-field">
                                <Skeleton height={12} width="30%"/>
                                <Skeleton height={32}/>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default BnxtEditorSkeleton;
